import React from "react";

import { LadyMinV2DTO } from "@/models/lady-dtos";

import { LadyCardV3_builder } from "../LadyCardV3_builder";

type PropTypes = {
  ladyDto: LadyMinV2DTO;
  toggleFavoriteLady?: (id: number) => void;
  refetch: () => void;
};

export const LadyCardV3Favorite: React.FC<PropTypes> = ({
  ladyDto,
  toggleFavoriteLady,
  refetch,
}) => {
  return (
    <LadyCardV3_builder
      ladyDto={ladyDto}
      toggleFavoriteLady={toggleFavoriteLady}
      refetch={refetch}
    >
      <LadyCardV3_builder.Container>
        <LadyCardV3_builder.ImageWrapper>
          <LadyCardV3_builder.SideButtons skipFavoriteButton />
          <LadyCardV3_builder.Labels />
          <LadyCardV3_builder.RemoveBottomButton />
        </LadyCardV3_builder.ImageWrapper>
        <LadyCardV3_builder.Info />
      </LadyCardV3_builder.Container>
    </LadyCardV3_builder>
  );
};
